export default {
  commonPapersize: 'Štandardné veľkosti papiera',
  customerPapersize: 'Vlastná veľkosť papiera',
};
